import React, { useEffect } from 'react';

const OmniBot = ({ config }) => {
  useEffect(() => {
    if (!config?.deploymentId || !config?.orgId || !config?.appId) {
      console.error('OmniBot configuration is incomplete. Please check the bot-config-map.json file.');
      return;
    }

    // Define the configuration object with fallback defaults
    const omniConfig = {
      deploymentId: config.deploymentId,
      orgId: config.orgId,
      appId: config.appId,
      closeText: config.closeText || 'Default Close Text',
      infoText: config.infoText || 'Default Info Text',
      language: config.language || 'en',
      userType: config.userType || 'Default User',
      environment: config.environment || 'production',
    };

    // Add the config object to the global _omnibotJs array
    window._omnibotJs = window._omnibotJs || [];
    window._omnibotJs.push(omniConfig);

    // Function to load the OmniBot script
    const loadScript = () => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = config.scriptUrl || 'https://app.fldor.omnibots.ai/omnibot-launcher.js'; // Placeholder or default script URL
      document.body.appendChild(script);
    };

    // Load the script if the document is ready
    if (document.readyState === 'complete') {
      loadScript();
    } else if (window.addEventListener) {
      window.addEventListener('load', loadScript, false);
    } else {
      window.attachEvent('onload', loadScript);
    }

    // Cleanup script and configuration on unmount
    return () => {
      // Remove OmniBot script
      const script = document.querySelector(
        `script[src="${config.scriptUrl || 'https://app.fldor.omnibots.ai/omnibot-launcher.js'}"]`
      );
      if (script) {
        document.body.removeChild(script);
      }

      // Clear the global _omnibotJs array for the current configuration
      if (window._omnibotJs) {
        window._omnibotJs = window._omnibotJs.filter(
          (botConfig) =>
            botConfig.deploymentId !== omniConfig.deploymentId ||
            botConfig.orgId !== omniConfig.orgId ||
            botConfig.appId !== omniConfig.appId
        );
      }

      console.log('OmniBot resources cleaned up.');
    };
  }, [config]);

  return null; // OmniBot does not render anything directly
};

export default OmniBot;
